import { render, staticRenderFns } from "./reportError.vue?vue&type=template&id=a247225a&scoped=true&"
import script from "./reportError.vue?vue&type=script&lang=js&"
export * from "./reportError.vue?vue&type=script&lang=js&"
import style0 from "./reportError.vue?vue&type=style&index=0&id=a247225a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a247225a",
  null
  
)

export default component.exports